import { Routes } from '@angular/router';
import { LoginComponent } from './ui/login/login.component';
import { ResetPasswordComponent } from './ui/reset-password/reset-password.component';
import { PortalComponent } from './ui/portal/portal.component';
import { ChangelogComponent } from './ui/changelog/changelog.component';
import { authGuard } from './helper/services/auth.guard';
import { unsavedChangesGuard } from './helper/services/unsaved-changes.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'portal', component: PortalComponent, canActivate: [authGuard], canDeactivate: [unsavedChangesGuard] },
  { path: 'changelog', component: ChangelogComponent },
];
